export const educationData = [
    {
        id: 1,
        institution: 'Rukmini Devi Public School',
        course: 'High School',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Delhi Technological University',
        course: 'Bachelor of Technology',
        startYear: '2020',
        endYear: '2024'
    }
]